import { AppNS } from 'app';
import { Link } from 'react-router-dom';

import { Box, Button, Toolbar } from '@mui/material';

import ToolbarLogo from './toolbar-logo/ToolbarLogo';
import ToolbarMenu from './toolbar-menu/ToolbarMenu';

const loginItems = [{ id: 'login', href: '/auth/login', name: 'Log In' }] as Array<AppNS.ToolbarMenuItem>;

export default function ToolbarNotLogged() {
  return (
    <Toolbar disableGutters>
      <ToolbarLogo></ToolbarLogo>
      <Box flexGrow="1" />
      <ToolbarMenu menuItems={loginItems} noFloatingMenu={true}></ToolbarMenu>

      <Button type="submit" variant="contained" color="primary" disableElevation component={Link} to="/../access-dc">
        Register
      </Button>
    </Toolbar>
  );
}
